<template>
  <div class="graphRadar-list">
    <v-card
      min-height="400"
      rounded="lg"
      elevation="6"
    >
        <v-app-bar flat >
          <v-icon>mdi-pentagon-outline</v-icon>
          <v-toolbar-title class="title pl-1">
            {{$t('profile.material.graphradar')}}
          </v-toolbar-title>
          <v-spacer></v-spacer>
          <v-menu offset-y>
                <template v-slot:activator="{ on, attrs }">
                  <v-btn

                    icon
                    v-bind="attrs"
                    v-on="on"
                  >
                    <v-icon>mdi-dots-vertical</v-icon>
                  </v-btn>
                </template>
                <v-list>
                  <v-list-item >
                    <v-list-item-title>
                      <v-btn @click="exportToImage">
                        {{$t('global.export')}}
                      </v-btn>
                    </v-list-item-title>
                  </v-list-item>
                </v-list>
          </v-menu>
        </v-app-bar>
      <v-card-text >
        <v-container class="white" rounded="lg">
          <canvas aura:id="graphRadar" id="graphRadar" width="400" height="400"></canvas>
        </v-container>
      </v-card-text>
      <v-card-actions>
        <v-expansion-panels v-model="reveal">
          <v-expansion-panel>
            <v-expansion-panel-header>
              {{ $t('global.filters') }}

              <template slot="actions">
                <v-icon large>mdi-filter-variant</v-icon>
              </template>
            </v-expansion-panel-header>
            <v-expansion-panel-content>
              <slot name="filter"></slot>
              <v-combobox
                v-model="dataSelected"
                :items="dataCombo"
                multiple
                dense
                item-text="name"
                item-value="value"
              >

                <template v-slot:selection="data">
                  <v-chip class="ma-1 accent">
                    <span>{{ data.item.name }}</span>
                  </v-chip>
                </template>

              </v-combobox>
              <v-btn color="primary" @click="updateGraph">{{ $t('global.filters')}}</v-btn>
              <v-btn class="ml-2"  @click="handleReset">{{ $t('global.reset')}}</v-btn>
            </v-expansion-panel-content>
          </v-expansion-panel>
        </v-expansion-panels>
    </v-card-actions>
    </v-card>

  </div>
</template>

<script>
import { Chart } from 'chart.js';
import { mapActions, mapGetters } from 'vuex';
import { mapFields } from 'vuex-map-fields';
import AccessMixin from '../../mixins/AccessMixin';

export default {
  name: 'graphRadar',
  servicePrefix: 'MaterialType',
  mixins: [AccessMixin],
  components: {

  },
  props: {
    materialtype: {
      type: Object,
      required: false,
      default: () => null
    },
  },
  data() {
    return {

      measureGraphData: null,
      ctx: null,
      graphRadar: null,
      options: {
        responsive: true,
        elements: {
          line: {
            borderWidth: 5,
          }
        },
        tooltips: {
            callbacks: {
                title: function(value,data) {
                  return data.labels[value[0].index];
                },
                label: function(value) {
                  return value.value;
                }
            }
        },
        scale: {
            angleLines: {
                display: false
            },
            ticks: {
                suggestedMin: 0,
                suggestedMax: 100
            }
        },
      },

      reveal: false,
      dataCombo: [{name: this.$t('profile.material.tempresistance'), value: "tempresistance"},
      {name: this.$t('profile.material.chemicalresistance'), value: "chemicalresistance"},
      {name: this.$t('profile.material.uvresistance'), value: "uvresistance"},
      {name: this.$t('profile.material.mecaresistance'), value: "mecaresistance"},
      {name: this.$t('profile.material.abrasionresistance'), value: "abrasionresistance"},
      {name: this.$t('profile.material.tractionresistance'), value: "tractionresistance"},
      {name: this.$t('profile.material.complexity'), value: "complexity"},
      {name: this.$t('profile.material.density'), value: "density"},
      {name: this.$t('profile.material.tenacity'), value: "tenacity"},
      {name: this.$t('profile.material.cost'), value: "cost"},
      {name: this.$t('profile.material.electrical'), value: "electrical"},
      {name: this.$t('profile.material.thermal'), value: "thermal"},
      {name: this.$t('profile.material.dielectric'), value: "dielectric"},
      {name: this.$t('profile.material.hardness'), value: "hardness"},
      {name: this.$t('profile.material.tempfusion'), value: "tempfusion"}
      ],
      dataSelected: [
        {name: this.$t('profile.material.tempresistance'), value: "tempresistance"},
        {name: this.$t('profile.material.chemicalresistance'), value: "chemicalresistance"},
        {name: this.$t('profile.material.uvresistance'), value: "uvresistance"},
        {name: this.$t('profile.material.mecaresistance'), value: "mecaresistance"},
        {name: this.$t('profile.material.abrasionresistance'), value: "abrasionresistance"},
      ],
    };
  },
  mounted() {
    this.loadMeasureGraph();
    this.ctx = document.getElementById('graphRadar').getContext('2d');
  },
  computed: {
    ...mapFields('materialtype', {
      actioned: 'actioned',
      action: 'action',
      updatedata: 'updatedata',
      error: 'error',
      isLoading: 'isLoading'
    }),
    ...mapGetters('materialtype',{
      dataMeasure: 'data',
    }),
    measureGraph: {
      get() { return this.measureGraphData },
       set(value) { this.measureGraphData = value; }
    },
  },
  methods: {
    ...mapActions({
      materialtypeGetData: 'materialtype/data'
    }),
    loadMeasureGraph() {
      this.materialtypeGetData({data: 'measuregraphmaterialtype/'+this.materialtype['id']});
    },
    handleReset() {
      this.dataSelected = [
        {name: this.$t('profile.material.tempresistance'), value: "tempresistance"},
        {name: this.$t('profile.material.chemicalresistance'), value: "chemicalresistance"},
        {name: this.$t('profile.material.uvresistance'), value: "uvresistance"},
        {name: this.$t('profile.material.mecaresistance'), value: "mecaresistance"},
        {name: this.$t('profile.material.abrasionresistance'), value: "abrasionresistance"},
      ];
      this.updateGraph();
    },
    createGraph() {


      var datasets1 = {
        label: this.materialtype['name'],
        data: [],
        borderColor: '#fdb913',
        pointBackgroundColor: '#fdb913',
        pointBorderColor: '#fff',
        pointHoverBackgroundColor: '#fff',
        pointHoverBorderColor: '#fff'
      };
      var labels  = [ ];
      for (var i = 0; i < this.dataSelected.length; i++) {

        switch(this.dataSelected[i].value) {
          case 'tempresistance':
            labels.push(this.dataSelected[i].name);
            datasets1['data'].push(this.measureGraphData[1].tempResistance);
            break;
          case 'chemicalresistance':
            labels.push(this.dataSelected[i].name);
            datasets1['data'].push(this.measureGraphData[1].chemicalResistance);
            break;
          case 'uvresistance':
            labels.push(this.dataSelected[i].name);
            datasets1['data'].push(this.measureGraphData[1].uvResistance);
            break;
          case 'mecaresistance':
            labels.push(this.dataSelected[i].name);
            datasets1['data'].push(this.measureGraphData[1].mecaResistance);
            break;
          case 'abrasionresistance':
            labels.push(this.dataSelected[i].name);
            datasets1['data'].push(this.measureGraphData[1].abrasionResistance);
            break;
          case 'tractionresistance':
            labels.push(this.dataSelected[i].name);
            datasets1['data'].push(this.measureGraphData[1].tractionResistance);
            break;
          case 'complexity':
            labels.push(this.dataSelected[i].name);
            datasets1['data'].push(this.measureGraphData[1].complexity);
            break;
          case 'density':
            labels.push(this.dataSelected[i].name);
            datasets1['data'].push(this.measureGraphData[1].density);
            break;
          case 'tenacity':
            labels.push(this.dataSelected[i].name);
            datasets1['data'].push(this.measureGraphData[1].tenacity);
            break;
          case 'cost':
            labels.push(this.dataSelected[i].name);
            datasets1['data'].push(this.measureGraphData[1].cost);
            break;
          case 'electrical':
            labels.push(this.dataSelected[i].name);
            datasets1['data'].push(this.measureGraphData[1].electrical);
            break;
          case 'thermal':
            labels.push(this.dataSelected[i].name);
            datasets1['data'].push(this.measureGraphData[1].thermal);
            break;
          case 'dielectric':
            labels.push(this.dataSelected[i].name);
            datasets1['data'].push(this.measureGraphData[1].dielectric);
            break;
          case 'hardness':
            labels.push(this.dataSelected[i].name);
            datasets1['data'].push(this.measureGraphData[1].hardness);
            break;
          case 'tempfusion':
            labels.push(this.dataSelected[i].name);
            datasets1['data'].push(this.measureGraphData[1].tempFusion);
            break;
        }
      }

    /*
    var datasets2 = {
      label: 'My Second Dataset',
      data: [28, 48, 40, 19, 96, 27, 100],
      fill: true,
      backgroundColor: 'rgba(54, 162, 235, 0.2)',
      borderColor: 'rgb(54, 162, 235)',
      pointBackgroundColor: 'rgb(54, 162, 235)',
      pointBorderColor: '#fff',
      pointHoverBackgroundColor: '#fff',
      pointHoverBorderColor: 'rgb(54, 162, 235)'
    }
    */

      var options  = this.options;

      this.graphRadar = new Chart.Radar(this.ctx, {
        data: {
            labels: labels,
            datasets: [datasets1]
        },
        options: options
      });

    },
    updateGraph() {
      this.graphRadar.data.labels= [];
      this.graphRadar.data.datasets[0].data= [];
      for (var i = 0; i < this.dataSelected.length; i++) {

        switch(this.dataSelected[i].value) {
          case 'tempresistance':
            this.graphRadar.data.labels.push(this.dataSelected[i].name);
            this.graphRadar.data.datasets[0].data.push(this.measureGraphData[1].tempResistance);
            break;
          case 'chemicalresistance':
            this.graphRadar.data.labels.push(this.dataSelected[i].name);
            this.graphRadar.data.datasets[0].data.push(this.measureGraphData[1].chemicalResistance);
            break;
          case 'uvresistance':
            this.graphRadar.data.labels.push(this.dataSelected[i].name);
            this.graphRadar.data.datasets[0].data.push(this.measureGraphData[1].uvResistance);
            break;
          case 'mecaresistance':
            this.graphRadar.data.labels.push(this.dataSelected[i].name);
            this.graphRadar.data.datasets[0].data.push(this.measureGraphData[1].mecaResistance);
            break;
          case 'abrasionresistance':
            this.graphRadar.data.labels.push(this.dataSelected[i].name);
            this.graphRadar.data.datasets[0].data.push(this.measureGraphData[1].abrasionResistance);
            break;
          case 'tractionresistance':
            this.graphRadar.data.labels.push(this.dataSelected[i].name);
            this.graphRadar.data.datasets[0].data.push(this.measureGraphData[1].tractionResistance);
            break;
          case 'complexity':
            this.graphRadar.data.labels.push(this.dataSelected[i].name);
            this.graphRadar.data.datasets[0].data.push(this.measureGraphData[1].complexity);
            break;
          case 'density':
            this.graphRadar.data.labels.push(this.dataSelected[i].name);
            this.graphRadar.data.datasets[0].data.push(this.measureGraphData[1].density);
            break;
          case 'tenacity':
            this.graphRadar.data.labels.push(this.dataSelected[i].name);
            this.graphRadar.data.datasets[0].data.push(this.measureGraphData[1].tenacity);
            break;
          case 'cost':
            this.graphRadar.data.labels.push(this.dataSelected[i].name);
            this.graphRadar.data.datasets[0].data.push(this.measureGraphData[1].cost);
            break;
          case 'electrical':
            this.graphRadar.data.labels.push(this.dataSelected[i].name);
            this.graphRadar.data.datasets[0].data.push(this.measureGraphData[1].electrical);
            break;
          case 'thermal':
            this.graphRadar.data.labels.push(this.dataSelected[i].name);
            this.graphRadar.data.datasets[0].data.push(this.measureGraphData[1].thermal);
            break;
          case 'dielectric':
            this.graphRadar.data.labels.push(this.dataSelected[i].name);
            this.graphRadar.data.datasets[0].data.push(this.measureGraphData[1].dielectric);
            break;
          case 'hardness':
            this.graphRadar.data.labels.push(this.dataSelected[i].name);
            this.graphRadar.data.datasets[0].data.push(this.measureGraphData[1].hardness);
            break;
          case 'tempfusion':
            this.graphRadar.data.labels.push(this.dataSelected[i].name);
            this.graphRadar.data.datasets[0].data.push(this.measureGraphData[1].tempFusion);
            break;


        }
      }
      this.graphRadar.options  = this.options;
      this.graphRadar.update();

    },
    exportToImage() {
      var a = document.createElement('a');
      a.href = this.graphRadar.toBase64Image();
      a.download = 'graphRadar.png';
      // Trigger the download
      a.click();
    },

  },
  watch: {
    updatedata: function (updatedata) {
      if ( updatedata.includes("measuregraphmaterialtype/")) {
        this.measureGraphData = this.dataMeasure(updatedata);
        this.createGraph();
      }
    },
  }
};
</script>
